import request from '../utils/request'

export function add(object) {
    return request.post('/notice', object)
}

export function put(object) {
    return request.put('/notice', object)
}

export function list(object) {
    return request.post('/notice/list', object)
}

export function frontList(object) {
    return request.post('/notice/front/list', object)
}

export function deleteById(id) {
    return request.delete('/notice/'+id)
}

export function queryById(id) {
    return request.get('/notice/'+id)
}

export function getNoticeTypeAll() {
    return request.post('/notice/getNoticeTypeAll')
}

export function getRandomRows(numRows) {
    return request.get('/notice/getRandomRows/'+numRows)
}

